import { fixIsoDate } from '@/helpers'
/**
 * Get date string in locale format
 */
const dateFormat = (date, language = 'ru') => {
  if (!date) {
    return ''
  }

  const formattedDate = fixIsoDate(date)
  const dateObject = new Date(formattedDate)

  return dateObject.toLocaleDateString(language)
}

export default {
  dateFormat
}
